import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, IconButton  } from '@mui/material';
import React, { useEffect,  useRef, useState } from 'react';
import { commonFilter, convertCase, getUniqueFilteredData } from '../../../SharedFiles/Helper/utils';
import { useSelector } from 'react-redux';
// import { MdQrCodeScanner } from 'react-icons/md'; 
// import { Html5QrcodeScanner } from 'html5-qrcode';
// import QrContainer,{qrItemCode} from '../SharedFiles/QRCode/qrReader';
import QrContainer from '../../../SharedFiles/QRCode/qrReader';
import CloseIcon from '@mui/icons-material/Close'; 
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';


const GRPOModal = ({
    modalOpen, setModalOpen, headers, setFormData, formData,
    handleInputChangeInternal, handleAddRow,
    handleFieldClear, disabledFieldsTrigger, editMode, handleCloseModal,
    filteredData, activeField, setActiveField, handleDropClick,
    setFilteredDataState, filteredDataState, errorMessage, tableRows,openManual,setOpenManual,handleQrScan
}) => {
    const { t } = useTranslation();
    const { GetPoData, GrpoItmData, loading, error } = useSelector((state) => state.grpo);
    const [searchTerm, setSearchTerm] = useState("");
    const [disabledFields, setDisabledFields] = useState([]);
    const readerRef = useRef(null); 
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setFilteredDataState([]); // Close the dropdown
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    useEffect(() => {
        const checkDisabledFields = () => {
            if (disabledFieldsTrigger) {
                const updatedDisabledFields = {};
                
                if (editMode) {
                    headers.forEach((header) => {
                        if (formData[header] !== ''
                            && header !== 'actual_Gross_Wt') {
                            updatedDisabledFields[header] = true;
                        } else {
                            // Enable the field if it's either empty, 'gross_Wt', or 'net_Wt'
                            updatedDisabledFields[header] = false;
                        }
                    });
                } else {
                    headers.forEach((header) => {
                        if (formData[header] !== "" && header !== 'coil_Id') {
                            updatedDisabledFields[header] = true;
                        } else {
                            updatedDisabledFields[header] = false;
                        }
                    });
                }
                
                // Update the state with the new disabled fields
                setDisabledFields(updatedDisabledFields);
            } else {
                setDisabledFields([]);
            }
        };
        
        checkDisabledFields();
    }, [disabledFieldsTrigger, editMode]);


    useEffect(() => {
        // Dynamically filter the dropdown data as user types
        if (searchTerm === "") {
            // Reset to the original data when searchTerm is empty
            setFilteredDataState(GrpoItmData);
        } else if (Array.isArray(filteredData) && filteredData.length > 0) {
            // Update the filtered data state only if filteredData is a non-empty array
            setFilteredDataState(filteredData);
        } else if (searchTerm !== "" && filteredData.length === 0) {
            setFilteredDataState([]);
        }
    }, [searchTerm, filteredData, GrpoItmData]);

    // useEffect(() => {
    //     // Initialize the QR scanner only after the reader element is available in the DOM
    //     if (scannerActive && readerRef.current) {
    //         const scanner = new Html5QrcodeScanner(readerRef.current, {
    //             qrbox: { width: 250, height: 250 },
    //             fps: 10
    //         });

    //         scanner.render(success);

    //         function success(result) {
    //             qrItemCode = result;
    //             setScannerActive(false); // Close the scanner after a successful scan
    //             scanner.clear(); // Clear the scanner
    //         }
    //     }
    // }, [scannerActive]);

    // const handleQrScannerClick = () => {
    //     setScannerActive(true); // Show the scanner when the icon is clicked
    // };


    const formattedHeadersMap = headers.reduce((acc, header) => {
        acc[header] = t(convertCase(header));
        return acc;
    }, [headers]);

    const handleInputChange = (e, header) => {
        const { value } = e.target;
        setActiveField(header); // Set the active field when an input is selected
        handleInputChangeInternal(e.target.value, header); // Handle the input change logic
        setSearchTerm(value);        
    };

    // const handleCloseModal = () => {
    //     setModalOpen(false);
    //     setFormData({});
    // };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleAddRow(formData);  
        setSearchTerm("");
    };

    const handleActiveField = (header) => {        
        setActiveField(header);
        let filterData = [];
        const uniqueValue = getUniqueFilteredData(GrpoItmData, header);        
        if(formData.item_Code === ""){
            filterData = uniqueValue;
        }
        else{
            filterData = commonFilter(uniqueValue,'item_Code', formData.item_Code)
        }
        setFilteredDataState(filterData);
    };


    // const handleQrScan = (scanResult) => {
    //     setQrScanResult(scanResult);
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         coil_Id: scanResult, 
    //     }));
    //     setOpenManual(true);
    // };

    return (
        <Dialog open={modalOpen} onClose={handleCloseModal}>
            <DialogTitle className='Modal-heading'>{t('Add Item')}
            <IconButton 
                    edge="end" 
                    color="inherit" 
                    onClick={handleCloseModal}
                    style={{ position: 'absolute', right: '18px', top: '10px' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className="custom-dialog-content">
               {openManual ? (
                <form id="form" onSubmit={(e) => handleSubmit(e, formData)}>
                    {headers?.map((header, index) => (                        
                         header === 'line_Id' ? null : (
                             <div key={index} style={{ marginBottom: '16px' }}>
                                <TextField
                                    fullWidth
                                    label={formattedHeadersMap[header]}
                                    variant="outlined"
                                    name={header}
                                    value={formData[header] || ""}
                                    onChange={(e) => handleInputChange(e, header)} // Track the field being edited
                                    required
                                    onClick={() => handleActiveField(header)}
                                    disabled={disabledFields[header]}
                                    error={!!errorMessage[header]}
                                    helperText={errorMessage[header]}
                                    autoComplete="off"
                                    className="custom-modal-textfield"
                                />
    
                            {/* Show the dropdown for the respective field if it's the active field */}
                            {activeField === header
                                && filteredDataState?.length > 0
                                && (header === 'coil_Id' || header === 'item_Code' || header === 'item_Name')
                                && (
                                    <div className="dropdown-container" ref={dropdownRef}>
                                         {filteredDataState
                                            ?.filter(item => {
                                                // Exclude the coil_Id value that is already selected in the table
                                                return item[header] != null && item[header] !== '' && 
                                                (header !== 'coil_Id' || 
                                                    !tableRows.some(row => row.coil_Id === item[header])); // Exclude selected coil_Id
                                                })
                                           .map((item, idx) => (
                                            <div className='dropdown-style'
                                                key={idx}
                                                onClick={() => handleDropClick(item, header)} // Handle selection
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                            >
                                                {item[header]}
                                            </div>
                                        ))}
                                    </div>
                                )}
                        </div> 
                        )
                    ))}
                </form>
               ) : (
                <div>
                <QrContainer 
                    elementId="GRPO" 
                    openManual={openManual}
                    onScan={handleQrScan} />
                </div>
            )}
            </DialogContent>
            <DialogActions className="custom-dialog-actions">
                <Button onClick={() => setOpenManual(!openManual)}>
                    {openManual ? "Scanner" : "Manual"}
                </Button>
                <Button onClick={handleCloseModal} className='Modal-cancel'>Cancel</Button>
                <Button type="submit" form="form" className='Modal-submit'> {editMode ? 'Update' : 'Add'}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default GRPOModal;
